import { Contact } from "../crm/contact.model";

export class FormGroupPrimaryContact extends Contact {
  formGroupInstanceId: number;
}
